import {
  getWidgetShadowRoot,
  removeScopedStyleTag,
  upsertScopedStyleTag,
} from "../../domStyles";
import { getFeatureTarget } from "../../featureTargets";

const FEATURE_ID = "high-saturation";
const STYLE_ID = "incluway-high-saturation-style";
const CLASS = "incluway-high-saturation";

function getWidgetHtmlEl(): HTMLElement | null {
  const shadowRoot = getWidgetShadowRoot();
  return shadowRoot?.querySelector("html") ?? null;
}

export function enableHighSaturation() {
  document.documentElement.classList.add(CLASS);
  getWidgetHtmlEl()?.classList.add(CLASS);

  upsertScopedStyleTag({
    id: STYLE_ID,
    target: getFeatureTarget(FEATURE_ID, "both"),
    pageCss: `
html.${CLASS} {
  filter: saturate(200%) !important;
}
`.trim(),
    widgetCss: `
html.${CLASS} {
  filter: saturate(200%) !important;
}
`.trim(),
  });
}

export function disableHighSaturation() {
  document.documentElement.classList.remove(CLASS);
  getWidgetHtmlEl()?.classList.remove(CLASS);

  removeScopedStyleTag(STYLE_ID);
}
